/**
 * @param {string} watermarkText Watermark text
 * @returns {HTMLDivElement} Watermark DOM Element
 */
function createWatermark(watermarkText) {
  // Get current date
  const currentDate = new Date()
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth() + 1
  const day = currentDate.getDate()
  const currentDateString = `${year}-${month}-${day}`
  const txt=`${watermarkText} ${currentDateString}`;
  const can = document.createElement('canvas')
  const ctx = can.getContext('2d')
  can.width =  ctx.measureText(txt).width*2.5
  can.height = can.width/1.5

  ctx.font = '14px Microsoft YaHei'
  ctx.fillStyle = 'rgba(0, 0, 0, 0.2)'
  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'
  ctx.rotate(-20 * Math.PI / 180)


  ctx.fillText(txt, can.width / 10, can.height / 2)

  const div = document.createElement('div')
  div.style.pointerEvents = 'none'
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = '100%'
  div.style.height = '100%'
  div.style.background = `url(${can.toDataURL('image/png')}) repeat`
  return div
}

// Custom watermark directive
export default {
  bind(el, binding) {
    const { watermarkText } = binding.value

    const watermarkDiv = createWatermark(watermarkText)
    el.__watermark__ = watermarkDiv
    document.body.appendChild(watermarkDiv)
  },
  unbind(el) {
    if (el.__watermark__) {
      document.body.removeChild(el.__watermark__)
      delete el.__watermark__
    }
  }
}